import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import Img from '../../../Img' // task #67: canonical image component

function ConfigToolShowcase({ leftBox, rightTopBox, rightMiddleBox1, rightMiddleBox2, rightBottomBox }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.leftCol}>
          <div className={styles.leftBox}>
            <div className={styles.leftBoxText}>
              <div className={styles.title}><SimpleBlockContent blocks={leftBox.title} noSpace/></div>
              <div className={styles.subtitle}><SimpleBlockContent blocks={leftBox.subtitle} noSpace/></div>
            </div>
            <div className={styles.leftBoxImage}>
              {/* task #67: descriptor via <Img> */}
              <Img
                image={leftBox.image}
                alt={leftBox.title}
                objectFit="contain"
              />
            </div>
          </div>
        </div>
        <div className={styles.rightCol}>
          <div className={styles.bentoRow}>
            { renderRightColBox(rightTopBox) }
          </div>
          <div className={styles.bentoRow}>
            { renderRightColBox(rightMiddleBox1) }
            { renderRightColBox(rightMiddleBox2, 1) }
          </div>
          <div className={styles.bentoRow}>
            { renderRightColBox(rightBottomBox, 1) }
          </div>
        </div>
      </div>
    </div>
  )
}

const renderRightColBox = (bentoBox, order) => {
  return (
    <div className={styles.rightColBox}>
      <div className={styles.subtitle} style={order ? { order } : undefined}>
        <SimpleBlockContent blocks={bentoBox.subtitle} noSpace/>
      </div>
      <div className={styles.rightColImage}>
        {/* task #67: descriptor via <Img> */}
        <Img
          image={bentoBox.image}
          alt={bentoBox.subtitle}
          objectFit="contain"
        />
      </div>
    </div>
  )
}

export default ConfigToolShowcase
